class DrawerButton extends HTMLElement {
    constructor() {
        super();

        this.drawerId = this.dataset?.drawerId;

        this.drawer = document.getElementById(this.drawerId);

        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    connectedCallback() {
        if (!this.drawer) {
            console.error(`Drawer with id ${this.drawerId} not found`);
            return;
        }

        if (this.drawer.tagName !== 'DRAWER-COMPONENT') {
            console.error(`Drawer with id ${this.drawerId} is not a drawer-component element`);
            return;
        }

        this.addEventListener('click', this.toggleDrawer);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.toggleDrawer);
    }

    toggleDrawer() {
        this.drawer.toggleDrawer();
    }
}

customElements.define('drawer-button', DrawerButton);

class Drawer extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initVariables();

        if (!this.drawer) {
            console.error(`No dialog element found within drawer-component with id ${this.id}`);
            return;
        }
    }

    initVariables() {
        this.drawer = this.querySelector('dialog');

    }

    toggleDrawer() {
        if (this.drawer.hasAttribute('open')) {
            this.closeDrawer();
        } else {
            this.openDrawer();
        }
    }

    closeDrawer() {
        this.drawer.close();
    }

    openDrawer() {
        this.drawer.showModal();
    }
}

if (!customElements.get('drawer-component')) {
    customElements.define('drawer-component', Drawer);
}